import { OpConfigurationProfile, OpOperator } from '../core'
import { Utils } from '../util/utils'
import { IJsonSerializable } from '../util/interfaces'

import { ConvertHelper } from '../../helpers'
import { DataProvider } from '../../helpers/data-provider'

export class OpLocationConfigurationProfile implements IJsonSerializable {

    // #region Properties

    public configurationProfile: OpConfigurationProfile
    public appliedConfigurationProfile: OpConfigurationProfile
    public appliedDate: Date
    public appliedOperator: OpOperator
    public idLocation: number
    
    // #endregion


    // #region Properties

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }
    
    // #endregion


    // #region IJsonSerializable

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.configurationProfile = (opObj.ConfigurationProfile != null) ? new OpConfigurationProfile(opObj.ConfigurationProfile) : null
            this.appliedDate = (opObj.AppliedDate != null) ? ConvertHelper.stringToDate(opObj.AppliedDate) : null
            this.appliedOperator = (opObj.AppliedOperator != null) ? new OpOperator(opObj.AppliedOperator) : null
            this.appliedConfigurationProfile = (opObj.AppliedConfigurationProfile != null) ? new OpConfigurationProfile(opObj.AppliedConfigurationProfile) : null
            this.idLocation = opObj.IdLocation
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ConfigurationProfile: (this.configurationProfile != null) ? this.configurationProfile.toJSON() : null,
            AppliedConfigurationProfile: (this.appliedConfigurationProfile != null) ? this.appliedConfigurationProfile.toJSON() : null,
            AppliedDate: ConvertHelper.dateToString(this.appliedDate, { netFormat: true }),
            AppliedOperator: (this.appliedOperator != null) ? this.appliedOperator.toJSON() : null,
            IdLocation: this.idLocation
        }
    }
    
    // #endregion


    public static loadNavigationProperties(dataProvider: DataProvider, list: OpConfigurationProfile[]): JQueryPromise<OpConfigurationProfile[]> {
        return Utils.loadDataListNavigationProperties(dataProvider, list)
    }
}